import { render, staticRenderFns } from "./infoToYouth.vue?vue&type=template&id=632a0e6b&scoped=true&"
import script from "./infoToYouth.vue?vue&type=script&lang=js&"
export * from "./infoToYouth.vue?vue&type=script&lang=js&"
import style0 from "./infoToYouth.vue?vue&type=style&index=0&id=632a0e6b&lang=stylus&scoped=true&"
import style1 from "./infoToYouth.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a0e6b",
  null
  
)

export default component.exports